<template>
  <j-modal
    :title="title"
    width="70%"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :body-style="{ height: '580px', overflow: 'hidden', overflowY: 'scroll' }"
    :okButtonProps="{ class: { 'jee-hidden': true } }"
    @cancel="handleCancel"
    :cancelText="$t('关闭')"
  >
    <a-spin :spinning="confirmLoading">
      <a-descriptions>
        <a-descriptions-item :label="$t('表编号')"> {{ model.meterId }} </a-descriptions-item>
        <a-descriptions-item :label="$t('表类型')"> {{ model.mtName }} </a-descriptions-item>
        <a-descriptions-item :label="$t('表口径')"> {{ 'DN' + model.mtCaliber }} </a-descriptions-item>
      </a-descriptions>
      <a-tabs v-model="activeKey" @change="onTabChange">
        <a-tab-pane key="1" :tab="$t('轮检记录')">
          <!-- 查询区域 -->
          <div class="table-page-search-wrapper">
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('检定结果')">
                    <j-dict-select-tag v-model="queryParam.inspectionState" :showSearch="false" :placeholder="$t('请选择检定结果')" dictCode="verification_results" />
                  </a-form-item>
                </a-col>
                <a-col :xl="8" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('到检日期')">
                    <a-range-picker
                      v-model="date"
                      format="YYYY-MM-DD"
                      :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                      @change="onDateRangeChange"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('操作员')">
                    <j-select-user-by-dep v-model="queryParam.inspectionBy" :multi="false"></j-select-user-by-dep>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                    <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                    <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px"
                      >{{ $t('重置') }}</a-button
                    >
                    <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">{{ $t('新增') }}</a-button>
                    <a-button type="primary" icon="download" @click="handleExportXls($t('轮检记录'))" style="margin-left: 8px">{{ $t('导出') }}</a-button>
                    <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel"> 
                      <a-button type="primary" icon="import" style="margin-left: 8px">{{ $t('导入') }}</a-button>
                    </a-upload>
                    <a-button type="link" icon="download" @click="downloadFormWork($t('轮检模板'))">{{ $t('下载模板') }}</a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <!-- table区域-begin -->
          <div class="table-fixed">
            <a-table
              ref="table"
              size="middle"
              :scroll="{ x: true }"
              bordered
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :loading="loading"
              :components="drag(columns)"
              @change="handleTableChange"
            >
              <span slot="userAccount" slot-scope="text, record">
                  <a-tag style="font-size: 14px" :color="record.userAccountNum==null?'':record.userAccountNum<=0?'red': record.wtAlarmMoney<record.userAccountNum?'green':'orange'">{{record.userAccountNum}}</a-tag>
              </span>
              <template slot="userStateSlot" slot-scope="text">
                <a-button :class="text == 1 ? 'normalbg-status' : text == 0 ? 'unactivebg-status' : ''" v-if="text != null">
                  {{ text == 1 ? $t('已激活') : text == 0 ? $t('未激活') : '' }}
                </a-button>
              </template>
              <template slot="mtState" slot-scope="text, record">
                <a-tag style="font-size: 14px" v-if="text==0">{{
                  filterDictTextByCache('meter_state', text)
                }}</a-tag>
                <a-tag style="font-size: 14px" color="green" v-else-if="text==1">{{
                  filterDictTextByCache('meter_state', text)
                }}</a-tag>
                <a-tag style="font-size: 14px" color="blue" v-else-if="text==2">{{
                  filterDictTextByCache('meter_state', text)
                }}</a-tag>
                <a-tag style="font-size: 14px" color="red" v-else-if="text==3">{{
                  filterDictTextByCache('meter_state', text)
                }}</a-tag>
              </template>
              <template slot="inspectionState" slot-scope="text, record">
                <a-tag style="font-size: 14px" :color="text == 1 ? 'green' : 'red'" v-if="text != null">{{
                  filterDictTextByCache('verification_results', text)
                }}</a-tag>
              </template>
              <span slot="action" slot-scope="text, record">
                <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
                <a-divider type="vertical" />
                <a-dropdown>
                  <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
                  <a-menu slot="overlay">
                    <a-menu-item>
                      <a @click="handleDetail(record)">{{ $t('详情') }}</a>
                    </a-menu-item>
                    <a-menu-item>
                      <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                        <a>{{ $t('删除') }}</a>
                      </a-popconfirm>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </span>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="4" :tab="$t('维修记录')">
          <!-- 查询区域 -->
          <div class="table-page-search-wrapper">
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('维修原因')">
                    <j-dict-select-tag
                      v-model="queryParam.repairType"
                      :placeholder="$t('请选择维修原因')"
                      dictCode="repair_type"
                      :showSearch="false"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xl="8" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('维修时间')">
                    <a-range-picker
                      v-model="date"
                      format="YYYY-MM-DD"
                      :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                      @change="onDateRangeChange"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('操作员')">
                    <j-select-user-by-dep v-model="queryParam.repairBy" :multi="false"></j-select-user-by-dep>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                    <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                    <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px"
                      >{{ $t('重置') }}</a-button
                    >
                    <a-button type="primary" @click="handleAdd" icon="plus" style="margin-left: 8px">{{ $t('新增') }}</a-button>
                    <a-button type="primary" icon="download" @click="handleExportXls('meterinfo')" style="margin-left: 8px">{{ $t('导出') }}</a-button>
                    <a-upload
                      name="file"
                      :showUploadList="false"
                      :multiple="false"
                      :headers="tokenHeader"
                      :action="importExcelUrl"
                      @change="handleImportExcel"
                    >
                      <a-button type="primary" icon="import" style="margin-left: 8px">{{ $t('导入') }}</a-button>
                    </a-upload>
                    <a-button type="link" icon="download" @click="downloadFormWork($t('维修模板'))">{{ $t('下载模板') }}</a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <!-- table区域-begin -->
          <div class="table-fixed">
            <a-table
              ref="table"
              size="middle"
              :scroll="{ x: false }"
              bordered
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :loading="loading"
              :components="drag(columns)"
              @change="handleTableChange"
            >
              <span slot="action" slot-scope="text, record">
                <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
                <a-divider type="vertical" />
                <a @click="handleDetail(record)">{{ $t('详情') }}</a>
              </span>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="5" :tab="$t('返厂记录')">
          <!-- 查询区域 -->
          <div class="table-page-search-wrapper">
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('返厂原因')">
                    <j-dict-select-tag
                      v-model="queryParam.returnedType"
                      :placeholder="$t('请选择返厂原因')"
                      dictCode="returned_reason"
                      :showSearch="false"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xl="8" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('返厂时间')">
                    <a-range-picker
                      v-model="date"
                      format="YYYY-MM-DD"
                      :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                      @change="onDateRangeChange"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('操作员')">
                    <j-select-user-by-dep v-model="queryParam.returnedBy" :multi="false"></j-select-user-by-dep>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                    <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                    <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px"
                    >{{ $t('重置') }}</a-button
                    >
                    <a-button type="primary" @click="handleAdd" icon="plus" style="margin-left: 8px">{{ $t('新增') }}</a-button>
                    <a-button type="primary" icon="download" @click="handleExportXls($t('返厂记录'))" style="margin-left: 8px">{{ $t('导出') }}</a-button>
                    <a-upload
                      name="file"
                      :showUploadList="false"
                      :multiple="false"
                      :headers="tokenHeader"
                      :action="importExcelUrl"
                      @change="handleImportExcel"
                    >
                      <a-button type="primary" icon="import" style="margin-left: 8px">{{ $t('导入') }}</a-button>
                    </a-upload>
                    <a-button type="link" icon="download" @click="downloadFormWork($t('返厂模板'))">{{ $t('下载模板') }}</a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <!-- table区域-begin -->
          <div class="table-fixed">
            <a-table
              ref="table"
              size="middle"
              :scroll="{ x: false }"
              bordered
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :loading="loading"
              :components="drag(columns)"
              @change="handleTableChange"
            > 
              <template slot="returnedState" slot-scope="text, record">
                <a-tag style="font-size: 14px" :color="text==2?'green':text==3?'red':'blue'">{{filterDictTextByCache('returned_state',text)}}</a-tag>
              </template>
              <span slot="action" slot-scope="text, record">
                <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
                <a-divider type="vertical" />
                <a @click="handleDetail(record)">{{ $t('详情') }}</a>
              </span>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="3" :tab="$t('报废记录')">
          <!-- 查询区域 -->
          <div class="table-page-search-wrapper">
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('报废原因')">
                    <a-input v-model="queryParam.scrapReason" :placeholder="$t('请输入报废原因')" />
                  </a-form-item>
                </a-col>
                <a-col :xl="8" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('报废时间')">
                    <a-range-picker
                      v-model="date"
                      format="YYYY-MM-DD"
                      :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                      @change="onDateRangeChange"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('操作员')">
                    <j-select-user-by-dep v-model="queryParam.scrapBy" :multi="false"></j-select-user-by-dep>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                    <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                    <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px"
                      >{{ $t('重置') }}</a-button
                    >
                    <a-button type="primary" @click="handleAdd" icon="plus" style="margin-left: 8px">{{ $t('新增') }}</a-button>
                    <a-button type="primary" icon="download" @click="handleExportXls('meterinfo')" style="margin-left: 8px">{{ $t('导出') }}</a-button>
                    <a-upload
                      name="file"
                      :showUploadList="false"
                      :multiple="false"
                      :headers="tokenHeader"
                      :action="importExcelUrl"
                      @change="handleImportExcel"
                    >
                      <a-button type="primary" icon="import" style="margin-left: 8px">{{ $t('导入') }}</a-button>
                    </a-upload>
                    <a-button type="link" icon="download" @click="downloadFormWork($t('报废模板'))">{{ $t('下载模板') }}</a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <!-- table区域-begin -->
          <div class="table-fixed">
            <a-table
              ref="table"
              size="middle"
              :scroll="{ x: false }"
              bordered
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :loading="loading"
              :components="drag(columns)"
              @change="handleTableChange"
            >
              <span slot="action" slot-scope="text, record">
                <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
                <a-divider type="vertical" />
                <a @click="handleDetail(record)">{{ $t('详情') }}</a>
              </span>
            </a-table>
          </div>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
    <!-- 新增返厂记录 -->
    <MeterCycleModalReturnToFactory ref="MeterCycleModalReturnToFactoryRef" @ok="modalFormOk" />
    <!-- 新增轮检记录 -->
    <MeterCycleModalWheelInspection ref="MeterCycleModalWheelInspectionRef" @ok="modalFormOk" />
    <!-- 新增报废记录 -->
     <MeterCycleModalScrap ref="MeterCycleModalScrapRef" @ok="modalFormOk" />
     <!-- 新增维修记录 -->
     <MeterCycleModalRepair ref="MeterCycleModalRepairRef" @ok="modalFormOk" />
  </j-modal>
</template>
  
  <script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import TableDragResize from '@/mixins/TableDragResize'
import '@/assets/less/TableExpand.less'
import { getAction } from '@/api/manage'
import MeterCycleModalReturnToFactory from './MeterCycleModalReturnToFactory.vue'
import MeterCycleModalWheelInspection from './MeterCycleModalWheelInspection.vue'
import MeterCycleModalScrap from './MeterCycleModalScrap.vue'
import MeterCycleModalRepair from './MeterCycleModalRepair.vue'
import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
import JInput from '@/components/jeecg/JInput'
import { fileUrl } from '@/utils/util'
export default {
  mixins: [JeecgListMixin, TableDragResize],
  name: 'MeterCycleModalList',
  components: {
    JSelectUserByDep,
    JInput,
    MeterCycleModalReturnToFactory,
    MeterCycleModalWheelInspection,
    MeterCycleModalScrap,
    MeterCycleModalRepair
  },
  data() {
    return {
      filterDictTextByCache: filterDictTextByCache,
      title: '',
      width: 800,
      visible: false,
      disableSubmit: false,
      model: {},
      confirmLoading: false,
      validatorRules: {},
      url: {
        exportXlsUrl: "/jeecg-charge/meterInspectionRecord/exportXls",
        importExcelUrl: 'jeecg-charge/meterInspectionRecord/importExcel',
        delete: '/jeecg-charge/meterInspectionRecord/delete',

        list: '/jeecg-charge/meterInspectionRecord/listRecord',
        exportXlsUrl1: "/jeecg-charge/meterInspectionRecord/exportXls",
        importExcelUrl1: 'jeecg-charge/meterInspectionRecord/importExcel',
        delete1: '/jeecg-charge/meterInspectionRecord/delete',

        list2: '/jeecg-charge/meterInspectionRecord/list',

        list3: '/jeecg-charge/meterScrapRecord/list',
        exportXlsUrl3: "/jeecg-charge/meterScrapRecord/exportXls",
        importExcelUrl3: "jeecg-charge/meterScrapRecord/importExcel",
        delete3: '/jeecg-charge/meterScrapRecord/delete',

        list4: '/jeecg-charge/meterRepairRecord/list',
        exportXlsUrl4: "/jeecg-charge/meterRepairRecord/exportXls",
        importExcelUrl4: "jeecg-charge/meterRepairRecord/importExcel",
        delete4: '/jeecg-charge/meterRepairRecord/delete',
        
        list5: '/jeecg-charge/meterReturnedRecord/list',
        exportXlsUrl5: "/jeecg-charge/meterReturnedRecord/exportXls",
        importExcelUrl5: "jeecg-charge/meterReturnedRecord/importExcel",
        delete5: '/jeecg-charge/meterReturnedRecord/delete',

      },
      activeKey: '1',
      date: [],
      queryParam: {},
    }
  },
  computed: {
    // i18n：表格列使用 computed 以响应语言切换
    columns1() {
      return [
        {
          title: '#',
          dataIndex: 'index',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('表状态'),
          dataIndex: 'mtState',
          align: 'center',
          scopedSlots: { customRender: 'mtState' },
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('用户编号'),
          dataIndex: 'userId',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('出厂日期'),
          align: "center",
          dataIndex: 'productionTime',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('用户姓名'),
          dataIndex: 'userName',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('用户地址'),
          dataIndex: 'userAddr',
          align: 'center',
          width: 180,
          ellipsis: true,
        },
        {
          title: this.$t('检定结果'),
          dataIndex: 'inspectionState',
          align: 'center',
          scopedSlots: { customRender: 'inspectionState' },
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('检定日期'),
          dataIndex: 'inspectionTime',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('到检日期'),
          dataIndex: 'nextInspectionTime',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('操作员'),
          dataIndex: 'inspectionByName',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('添加时间'),
          dataIndex: 'createTime',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align:"center",
          fixed:"right",
          width:147,
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
    columns2() {
      return [
        {
          title: '#',
          dataIndex: 'index',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('出厂日期'),
          dataIndex: 'mtFactoryDate',
          align: 'center',
        },
        {
          title: this.$t('上次检定日期'),
          dataIndex: 'mtLastCheckDate',
          align: 'center',
        },
        {
          title: this.$t('检定结果'),
          dataIndex: 'mtCheckResult',
          align: 'center',
        },
      ]
    },
    columns3() {
      return [
        {
          title: '#',
          dataIndex: 'index',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('报废时间'),
          dataIndex: 'scrapTime',
          align: 'center',
        },
        {
          title: this.$t('报废原因'),
          dataIndex: 'scrapReason',
          align: 'center',
        },
        {
          title: this.$t('操作员'),
          dataIndex: 'scrapByName',
          align: 'center',
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align:"center",
          fixed:"right",
          width:147,
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
    columns4() {
      return [
        {
          title: '#',
          dataIndex: 'index',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('维修类型'),
          dataIndex: 'repairType',
          align: 'center',
          customRender: (t, r, index) => {
            return filterDictTextByCache('repair_type', t)
          },
        },
        {
          title: this.$t('维修时间'),
          dataIndex: 'repairTime',
          align: 'center',
        },
        {
          title: this.$t('操作员'),
          dataIndex: 'repairByName',
          align: 'center',
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align:"center",
          fixed:"right",
          width:147,
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
    columns5() {
      return [
        {
          title: '#',
          dataIndex: 'index',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('返厂状态'),
          dataIndex: 'returnedState',
          align: 'center',
          scopedSlots: { customRender: 'returnedState' },
        },
        {
          title: this.$t('返厂原因'),
          dataIndex: 'returnedType',
          align: 'center',
          customRender: (t, r, index) => {
            return filterDictTextByCache('returned_reason', t)
          },
        },
        {
          title: this.$t('返厂日期'),
          dataIndex: 'returnedTime',
          align: 'center',
        },
        {
          title: this.$t('操作员'),
          dataIndex: 'returnedByName',
          align: 'center',
        },
        {
          title: this.$t('完成日期'),
          dataIndex: 'finishedTime',
          align: 'center',
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align:"center",
          fixed:"right",
          width:147,
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.queryParam.meterId = record.meterId
      this.visible = true
      this.activeKey = '1'
      this.columns = this.columns1;
      this.loadData(1)
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {},
    handleCancel() {
      this.close()
    },
    loadData(arg) {
      let url = ''
      if (this.activeKey == 1) {
        url = this.url.list
      } else if (this.activeKey == 2) {
        url = this.url.list2
      } else if (this.activeKey == 3) {
        url = this.url.list3
      } else if (this.activeKey == 4) {
        url = this.url.list4
      } else if (this.activeKey == 5) {
        url = this.url.list5
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      var params = this.getQueryParams() //查询条件
      params.meterId = this.model.meterId;
      this.loading = true
      getAction(url, params).then(res => {
        if (res.success && res.result) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        } else {
          this.$message.warning(res.message)
        }
        this.loading = false
      })
    },
    onTabChange(e){
      this.activeKey = e
      switch(this.activeKey){
        case '1':
          this.columns = this.columns1;
          this.url.exportXlsUrl = this.url.exportXlsUrl1;
          this.url.importExcelUrl = this.url.importExcelUrl1;
          this.url.delete = this.url.delete1;
          break
        case '2':
          this.columns = this.columns2;
          break
        case '3':
          this.columns = this.columns3;
          this.url.exportXlsUrl = this.url.exportXlsUrl3;
          this.url.importExcelUrl = this.url.importExcelUrl3;
          this.url.delete = this.url.delete3;
          break
        case '4':
          this.columns = this.columns4;
          this.url.exportXlsUrl = this.url.exportXlsUrl4;
          this.url.importExcelUrl = this.url.importExcelUrl4;
          this.url.delete = this.url.delete4;
          break
        case '5':
          this.columns = this.columns5;
          this.url.exportXlsUrl = this.exportXlsUrl5;
          this.url.importExcelUrl = this.importExcelUrl5;
          this.url.delete = this.url.delete5;
          break
      }
      this.loadData(1)
    },
    handleAdd(){
      switch(this.activeKey){
        case '1':
          this.$refs.MeterCycleModalWheelInspectionRef.edit({meterId: this.model.meterId,productionTime:this.model.productionTime});
          this.$refs.MeterCycleModalWheelInspectionRef.title = this.$t('新增轮检');
          this.$refs.MeterCycleModalWheelInspectionRef.disableSubmit = false;
          break
        case '2':
          break
        case '3':
          this.$refs.MeterCycleModalScrapRef.edit({meterId: this.model.meterId});
          this.$refs.MeterCycleModalScrapRef.title = this.$t('新增报废');
          this.$refs.MeterCycleModalScrapRef.disableSubmit = false;
          break
        case '4':
          this.$refs.MeterCycleModalRepairRef.edit({meterId: this.model.meterId});
          this.$refs.MeterCycleModalRepairRef.title = this.$t('新增维修');
          this.$refs.MeterCycleModalRepairRef.disableSubmit = false;
          break
        case '5':
          this.$refs.MeterCycleModalReturnToFactoryRef.edit({meterId: this.model.meterId});
          this.$refs.MeterCycleModalReturnToFactoryRef.title = this.$t('新增返厂');
          this.$refs.MeterCycleModalReturnToFactoryRef.disableSubmit = false;
          break
      }
    },
    handleEdit(record){
      switch(this.activeKey){
        case '1':
          this.$refs.MeterCycleModalWheelInspectionRef.edit(record);
          this.$refs.MeterCycleModalWheelInspectionRef.title = this.$t('编辑轮检');
          this.$refs.MeterCycleModalWheelInspectionRef.disableSubmit = false;
          break
        case '2':
          break
        case '3':
          this.$refs.MeterCycleModalScrapRef.edit(record);
          this.$refs.MeterCycleModalScrapRef.title = this.$t('编辑报废');
          this.$refs.MeterCycleModalScrapRef.disableSubmit = false;
          break
        case '4':
          this.$refs.MeterCycleModalRepairRef.edit(record);
          this.$refs.MeterCycleModalRepairRef.title = this.$t('编辑维修');
          this.$refs.MeterCycleModalRepairRef.disableSubmit = false;
          break
        case '5':
          this.$refs.MeterCycleModalReturnToFactoryRef.edit(record);
          this.$refs.MeterCycleModalReturnToFactoryRef.title = this.$t('编辑返厂');
          this.$refs.MeterCycleModalReturnToFactoryRef.disableSubmit = false;
          break
      }
    },
    handleDetail(record){
      switch(this.activeKey){
        case '1':
          this.$refs.MeterCycleModalWheelInspectionRef.edit(record);
          this.$refs.MeterCycleModalWheelInspectionRef.title = this.$t('轮检详情');
          this.$refs.MeterCycleModalWheelInspectionRef.disableSubmit = true;
          break
        case '2':
          break
        case '3':
          this.$refs.MeterCycleModalScrapRef.edit(record);
          this.$refs.MeterCycleModalScrapRef.title = this.$t('报废详情');
          this.$refs.MeterCycleModalScrapRef.disableSubmit = true;
          break
        case '4':
          this.$refs.MeterCycleModalRepairRef.edit(record);
          this.$refs.MeterCycleModalRepairRef.title = this.$t('维修详情');
          this.$refs.MeterCycleModalRepairRef.disableSubmit = true;
          break
        case '5':
          this.$refs.MeterCycleModalReturnToFactoryRef.edit(record);
          this.$refs.MeterCycleModalReturnToFactoryRef.title = this.$t('返厂详情');
          this.$refs.MeterCycleModalReturnToFactoryRef.disableSubmit = true;
          break
      }
    },
    downloadFormWork(fileName) {
      console.log('下载批量报装模板')
      let deviceFileUrl = ''
      switch (this.activeKey) {
        case '1':
          deviceFileUrl = '/file/wheel_inspection.xls'
          break
        case '2':
          break
        case '3':
          deviceFileUrl = '/file/scrap_template.xls'
          break
        case '4':
          deviceFileUrl = '/file/repair_template.xls'
          break
        case '5':
          deviceFileUrl = '/file/return_to_factory_template.xls'
          break
      }
      let url = `${fileUrl}${deviceFileUrl}`
      if (!fileName || typeof fileName != 'string') {
        fileName = this.$t('导出文件')
      }
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      console.log(fileName)
      link.setAttribute('download', fileName + '.xls')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link) //下载完成移除元素
      window.URL.revokeObjectURL(link.href) //释放掉blob对象
    },
  },
}
</script>
<style scoped>
.table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table {
  border-right: 1px solid #e8e8e8;
}

.table-fixed /deep/ .resize-table-th {
  position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
  border: 1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
</style>